module.exports = __webpack_public_path__ + "media/speak.ece9fdbb.mp3";